import React, {Component} from 'react'
import {
  Box,
  Button,
  Heading,
  Text,
  VStack,
  Grid,
  GridItem,
  Card,
  HStack,
  Badge,
  Divider,
  Input,
  InputGroup,
  InputLeftElement,
  Icon
} from '@chakra-ui/react';
import { FiSearch } from 'react-icons/fi';
import './IngediendeSuggesties.css'
import Sidebar from '../Sidebar/Sidebar';
import Navigation from '../../Navigation/Navigation';
import MobileMenu from '../MobileMenu/MobileMenu';
import Footer from '../../../components/Footer/Footer';
import colors from '../../../theme/colors';

class IngediendeSuggesties extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobileMenuOpen: false,
      searchKeyword: '',
      filteredSuggestions: null
    };
  }
  
  componentDidMount() {
    // Load suggestions when component mounts
    if (this.props.loadSuggestions) {
      this.props.loadSuggestions();
    }
  }
  
  handleSearchChange = (event) => {
    const keyword = event.target.value;
    this.setState({ searchKeyword: keyword });
    
    if (keyword.trim() === '') {
      this.setState({ filteredSuggestions: null });
      return;
    }
    
    const suggestions = this.props.state.suggestions || { items: [] };
    const filtered = suggestions.items.filter(suggestion => 
      suggestion.text.toLowerCase().includes(keyword.toLowerCase())
    );
    
    this.setState({ 
      filteredSuggestions: {
        ...suggestions,
        items: filtered
      }
    });
  }

  handleOpenMobileMenu = () => {
    this.setState({ isMobileMenuOpen: true })
  }

  handleCloseMobileMenu = () => {
    this.setState({ isMobileMenuOpen: false })
  }

  componentWillUnmount() {
    // Ensure mobile menu is closed when component unmounts
    if (this.state.isMobileMenuOpen) {
      this.setState({ isMobileMenuOpen: false })
    }
  }
  render () {
    const suggestions = this.state.filteredSuggestions || this.props.state.suggestions || { items: [], page: 0 };
    const isFiltering = this.state.searchKeyword.trim() !== '';
    
    return (
      <>
        <Grid templateColumns="repeat(24, 1fr)" bg="gray.50" minHeight="100vh">
        {/* sidebar */}
        <GridItem
          as="aside"
          colSpan={{ base: 0, md: 4, lg: 3 }}
          display={{ base: "none", md: "block" }}
          bg="gray.50"
          minHeight={{ lg: '100vh' }}
          p={0}
        >
        <Sidebar
        state = {this.props.state}
        getFeed = {this.props.getFeed}
        onRouteChange = {this.props.onRouteChange}
        userVersion = {this.props.state.userVersion}
        resetSuggestionsPage = {this.props.resetSuggestionsPage}
        onLogout = {this.props.onLogout}
        />
        </GridItem>
        <GridItem
        as="main"
        colSpan={{ base: 24, md: 20, lg: 21 }}
        p={{ base: "8px", md: "10px" }}
        display="flex"
        flexDirection="column"
        minHeight="100vh"
        >
        <Navigation
        state = {this.props.state}
        onRouteChange = {this.props.onRouteChange}
        getFeed = {this.props.getFeed}
        onVersionChange = {this.props.onVersionChange}
        onLogout = {this.props.onLogout}
        onOpenFeedback = {this.props.onOpenFeedback}
        onOpenMobileMenu = {this.handleOpenMobileMenu}
        />

        <Box p={{ base: "16px", md: "40px" }} flex="1">
          <VStack spacing={6} align="stretch">
            <Heading as="h2" size="lg" textAlign="center" color="gray.600">
              Ingediende Suggesties
            </Heading>
            
            <Text color="gray.500" textAlign="center">
              Bekijk al uw ingediende suggesties
            </Text>
            
            {/* Only show search if user has suggestions */}
            {this.props.state.suggestions && this.props.state.suggestions.items && this.props.state.suggestions.items.length > 0 && (
              <Box maxWidth="400px" mx="auto">
                <InputGroup>
                  <InputLeftElement pointerEvents="none">
                    <Icon as={FiSearch} color="gray.400" />
                  </InputLeftElement>
                  <Input
                    placeholder="Zoek in uw suggesties..."
                    value={this.state.searchKeyword}
                    onChange={this.handleSearchChange}
                    bg="white"
                    borderRadius="md"
                    shadow="sm"
                  />
                </InputGroup>
                {isFiltering && (
                  <Text fontSize="sm" color="gray.600" mt={2} textAlign="center">
                    {suggestions.items.length} resultaten gevonden voor "{this.state.searchKeyword}"
                  </Text>
                )}
              </Box>
            )}
            
            {suggestions.items && suggestions.items.length > 0 ? (
              <VStack spacing={4} align="stretch">
                {suggestions.items.map((suggestion, index) => (
                  <SuggestionCard key={suggestion.id || index} suggestion={suggestion} />
                ))}
                
                {/* Only show pagination if there are multiple pages and not filtering */}
                {!isFiltering && (suggestions.hasNext || suggestions.hasPrev || suggestions.page > 0) && (
                  <Box textAlign="center" mt={6}>
                    <HStack justify="center" spacing={4}>
                      <Button
                        disabled={!suggestions.hasPrev}
                        onClick={() => this.props.onPaginationButtonClick && this.props.onPaginationButtonClick('Previous', 'suggestions')}
                        bg="blue.400"
                        color="white"
                        _hover={{ bg: 'blue.500' }}
                        _disabled={{ bg: 'gray.300', color: 'gray.500', cursor: 'not-allowed' }}
                      >
                        Vorige
                      </Button>
                      <Text color="gray.500">
                        Pagina {suggestions.page + 1}
                      </Text>
                      <Button
                        disabled={!suggestions.hasNext}
                        onClick={() => this.props.onPaginationButtonClick && this.props.onPaginationButtonClick('Next', 'suggestions')}
                        bg="blue.400"
                        color="white"
                        _hover={{ bg: 'blue.500' }}
                        _disabled={{ bg: 'gray.300', color: 'gray.500', cursor: 'not-allowed' }}
                      >
                        Volgende
                      </Button>
                    </HStack>
                  </Box>
                )}
              </VStack>
            ) : (
              <Box textAlign="center" py={12}>
                <Text fontSize="lg" color="gray.500">
                  {isFiltering ? 
                    `Geen suggesties gevonden voor "${this.state.searchKeyword}"` :
                    'U heeft nog geen suggesties ingediend'
                  }
                </Text>
                {isFiltering ? (
                  <Button
                    mt={4}
                    onClick={() => {
                      this.setState({ searchKeyword: '', filteredSuggestions: null });
                    }}
                    variant="outline"
                    borderColor={colors.primary.main}
                    color={colors.primary.main}
                    _hover={{ bg: colors.primary.pale }}
                    size="sm"
                  >
                    Filter wissen
                  </Button>
                ) : (
                  <Button
                    mt={4}
                    onClick={() => this.props.onRouteChange('suggestieIndienen')}
                    bg={colors.primary.main}
                    color="white"
                    _hover={{ bg: colors.primary.dark }}
                  >
                    Eerste Suggestie Indienen
                  </Button>
                )}
              </Box>
            )}
          </VStack>
        </Box>
        <Footer onRouteChange={this.props.onRouteChange} />

        </GridItem>
        </Grid>

        {/* Mobile Menu Drawer */}
        <MobileMenu
          isOpen={this.state.isMobileMenuOpen}
          onClose={this.handleCloseMobileMenu}
          onRouteChange={this.props.onRouteChange}
          userVersion={this.props.state.userVersion}
          resetSuggestionsPage={this.props.resetSuggestionsPage}
          onLogout={this.props.onLogout}
        />
      </>
    )
  }
}

class SuggestionCard extends Component {
  render() {
    const { suggestion } = this.props;

    return (
      <Card p={6} shadow="sm" _hover={{ shadow: 'md' }} transition="all 0.2s">
        <VStack align="stretch" spacing={3}>
          <HStack justify="space-between" align="start">
            <Badge
              colorScheme={suggestion.status === 'submitted' ? 'green' : 'yellow'}
              variant="solid"
            >
              {suggestion.status === 'submitted' ? 'Ingediend' : 'Bekeken'}
            </Badge>
            <Text fontSize="sm" color="gray.500">
              {suggestion.created_at ? 
                `${new Date(suggestion.created_at).toLocaleDateString('nl-NL')} ${new Date(suggestion.created_at).toLocaleTimeString('nl-NL', {hour: '2-digit', minute: '2-digit'})}` : 
                'Onbekende datum'}
            </Text>
          </HStack>
          
          <Divider />
          
          <Text color="gray.700" whiteSpace="pre-wrap">
            {suggestion.text}
          </Text>
          
          {suggestion.response && (
            <>
              <Divider />
              <Box>
                <Text fontSize="sm" fontWeight="bold" color="gray.600" mb={2}>
                  Reactie van vertegenwoordiger:
                </Text>
                <Text fontSize="sm" color="gray.600" fontStyle="italic">
                  {suggestion.response}
                </Text>
              </Box>
            </>
          )}
        </VStack>
      </Card>
    );
  }
}

export default IngediendeSuggesties